import { IconButton } from '@patrianna/core-components'
import clsx from 'classnames'
import * as PropTypes from 'prop-types'
import * as React from 'react'

// { name: 'MuiPickersDay' }

export interface DayProps {
  /** Day text */
  children: React.ReactNode
  /** Is today */
  current?: boolean
  /** Disabled? */
  disabled?: boolean
  /** Hidden? */
  hidden?: boolean
  /** Selected? */
  selected?: boolean
}

export const Day: React.FunctionComponent<DayProps> = ({ children, disabled, hidden, current, selected, ...other }) => {
  const className = clsx('MuiPickersDay-day', {
    'MuiPickersDay-hidden': hidden,
    'MuiPickersDay-current': current,
    'MuiPickersDay-daySelected': selected,
    'MuiPickersDay-dayDisabled': disabled,
  })

  return (
    <IconButton className={className} tabIndex={hidden || disabled ? -1 : 0} {...other}>
      <span className='mt-typography-body2' color='inherit'>
        {children}
      </span>
    </IconButton>
  )
}

Day.displayName = 'Day'

Day.propTypes = {
  current: PropTypes.bool,
  disabled: PropTypes.bool,
  hidden: PropTypes.bool,
  selected: PropTypes.bool,
}

export default Day
